import { Navigate, Route, Routes, useParams } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import B2BLoginPage from "./pages/Auth/B2BLoginPage";
import CompanyRegistrationPage from "./pages/Auth/CompanyRegistrationPage";
import ForgetPasswordPage from "./pages/Auth/ForgetPasswordPage";
import ModeratorForgotPasswordPage from "./pages/Auth/ModeratorForgotPasswordPage";
import ModeratorLoginPage from "./pages/Auth/ModeratorLoginPage";
import ModeratorResetPasswordPage from "./pages/Auth/ModeratorResetPasswordPage";
import ResetPasswordPage from "./pages/Auth/ResetPasswordPage";
import ContractsPage from "./pages/Contracts/ContractsPage";
import B2BDashboardPage from "./pages/Dashboard/B2BDashboardPage";
import DealWorkspacePage from "./pages/DealWorkspace/DealWorkspacePage";
import HomePage from "./pages/HomePage/HomePage";
import MarketIntelligencePage from "./pages/MarketIntelligence/MarketIntelligencePage";
import MatchResultsPage from "./pages/MatchResults/MatchResultsPage";
import MessagesPage from "./pages/Messages/MessagesPage";
import ModeratorKybBadgesPage from "./pages/Moderator/Kyb/ModeratorKybBadgesPage";
import ModeratorKybCompanyPage from "./pages/Moderator/Kyb/ModeratorKybCompanyPage";
import ModeratorKybQueuePage from "./pages/Moderator/Kyb/ModeratorKybQueuePage";
import ModeratorAnalyticsPage from "./pages/Moderator/ModeratorAnalyticsPage";
import ModeratorArticlesPage from "./pages/Moderator/ModeratorArticlesPage";
import ModeratorBillingPage from "./pages/Moderator/ModeratorBillingPage";
import ModeratorCompaniesPage from "./pages/Moderator/ModeratorCompaniesPage";
import ModeratorCompanyDetailPage from "./pages/Moderator/ModeratorCompanyDetailPage";
import ModeratorContractsPage from "./pages/Moderator/ModeratorContractsPage";
import ModeratorConversationsPage from "./pages/Moderator/ModeratorConversationsPage";
import ModeratorCoordinatorPage from "./pages/Moderator/ModeratorCoordinatorPage";
import ModeratorDashboardPage from "./pages/Moderator/ModeratorDashboardPage";
import ModeratorDealDetailPage from "./pages/Moderator/ModeratorDealDetailPage";
import ModeratorDealsPage from "./pages/Moderator/ModeratorDealsPage";
import ModeratorDetailPage from "./pages/Moderator/ModeratorDetailPage";
import ModeratorHsClassifierPage from "./pages/Moderator/ModeratorHsClassifierPage";
import ModeratorLeadSourcesPage from "./pages/Moderator/ModeratorLeadSourcesPage";
import ModeratorMatchingPage from "./pages/Moderator/ModeratorMatchingPage";
import ModeratorMatchingRunDetailPage from "./pages/Moderator/ModeratorMatchingRunDetailPage";
import ModeratorMatchingRunsPage from "./pages/Moderator/ModeratorMatchingRunsPage";
import ModeratorProductFeedbackPage from "./pages/Moderator/ModeratorProductFeedbackPage";
import ModeratorProfilePage from "./pages/Moderator/ModeratorProfilePage";
import ModeratorReadinessPage from "./pages/Moderator/ModeratorReadinessPage";
import ModeratorsPage from "./pages/Moderator/ModeratorsPage";
import ModeratorTradeEstimatePage from "./pages/Moderator/ModeratorTradeEstimatePage";
import ModeratorVerificationPage from "./pages/Moderator/ModeratorVerificationPage";
import NotificationsPage from "./pages/Notifications/NotificationsPage";
import OpportunitiesPage from "./pages/Opportunities/OpportunitiesPage";
import PlanUsagePage from "./pages/PlanUsage/PlanUsagePage";
import ProductServicePage from "./pages/ProductService/ProductServicePage";
import ProfilePage from "./pages/Profile/ProfilePage";
import ReadinessPage from "./pages/Readiness/ReadinessPage";
import RequestsPage from "./pages/Requests/RequestsPage";
import TradeEstimatePage from "./pages/TradeEstimate/TradeEstimatePage";
import TrustCompliancePage from "./pages/TrustCompliance/TrustCompliancePage";

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/b2b/login" element={<B2BLoginPage />} />
        <Route path="/b2b/forgot-password" element={<ForgetPasswordPage />} />
        <Route path="/b2b/reset-password" element={<ResetPasswordPage />} />
        <Route path="/b2b/register" element={<CompanyRegistrationPage />} />
        <Route path="/moderator/login" element={<ModeratorLoginPage />} />
        <Route path="/moderator/forgot-password" element={<ModeratorForgotPasswordPage />} />
        <Route path="/moderator/reset-password" element={<ModeratorResetPasswordPage />} />
        <Route path="/moderator/dashboard" element={<ModeratorDashboardPage />} />
        <Route path="/moderator/companies" element={<ModeratorCompaniesPage />} />
        <Route path="/moderator/companies/:id" element={<ModeratorCompanyDetailPage />} />
        <Route path="/moderator/verification" element={<ModeratorVerificationPage />} />
        <Route path="/moderator/kyb" element={<ModeratorKybQueuePage />} />
        <Route path="/moderator/kyb/badges" element={<ModeratorKybBadgesPage />} />
        <Route path="/moderator/kyb/companies/:id" element={<ModeratorKybCompanyPage />} />
        <Route path="/moderator/provider-verification" element={<Navigate to="/moderator/kyb" replace />} />
        <Route path="/moderator/provider-verification/companies/:id" element={<LegacyKybRedirect />} />
        <Route path="/moderator/deals" element={<ModeratorDealsPage />} />
        <Route path="/moderator/deals/:id" element={<ModeratorDealDetailPage />} />
        <Route path="/moderator/coordinator" element={<ModeratorCoordinatorPage />} />
        <Route path="/moderator/contracts" element={<ModeratorContractsPage />} />
        <Route path="/moderator/conversations" element={<ModeratorConversationsPage />} />
        <Route path="/moderator/product-feedback" element={<ModeratorProductFeedbackPage />} />
        <Route path="/moderator/hs-classifier" element={<ModeratorHsClassifierPage />} />
        <Route path="/moderator/duty-estimate" element={<ModeratorTradeEstimatePage />} />
        <Route path="/moderator/articles" element={<ModeratorArticlesPage />} />
        <Route path="/moderator/lead-sources" element={<ModeratorLeadSourcesPage />} />
        <Route path="/moderator/readiness" element={<ModeratorReadinessPage />} />
        <Route path="/moderator/billing" element={<ModeratorBillingPage />} />
        <Route path="/moderator/matching" element={<ModeratorMatchingPage />} />
        <Route path="/moderator/matching/runs" element={<ModeratorMatchingRunsPage />} />
        <Route path="/moderator/matching/runs/:id" element={<ModeratorMatchingRunDetailPage />} />
        <Route path="/moderator/moderators" element={<ModeratorsPage />} />
        <Route path="/moderator/moderators/:id" element={<ModeratorDetailPage />} />
        <Route path="/moderator/analytics" element={<ModeratorAnalyticsPage />} />
        <Route path="/moderator/profile" element={<ModeratorProfilePage />} />
        <Route path="/b2b/dashboard" element={<B2BDashboardPage />} />
        <Route path="/b2b/product-service" element={<ProductServicePage />} />
        <Route path="/b2b/requests" element={<RequestsPage />} />
        <Route path="/b2b/match-results" element={<MatchResultsPage />} />
        <Route path="/b2b/opportunities" element={<OpportunitiesPage />} />
        <Route path="/b2b/readiness" element={<ReadinessPage />} />
        <Route path="/b2b/deals/:id" element={<DealWorkspacePage />} />
        <Route path="/b2b/trust-compliance" element={<TrustCompliancePage />} />
        <Route path="/b2b/duty-estimate" element={<TradeEstimatePage />} />
        <Route path="/b2b/market-intelligence" element={<MarketIntelligencePage />} />
        <Route path="/b2b/messages" element={<MessagesPage />} />
        <Route path="/b2b/contracts" element={<ContractsPage />} />
        <Route path="/b2b/notifications" element={<NotificationsPage />} />
        <Route path="/b2b/plan-usage" element={<PlanUsagePage />} />
        <Route path="/b2b/profile" element={<ProfilePage />} />
      </Routes>
    </Layout>
  );
}

export default App;

/** Old provider-verification links now open the KYB workspace. */
function LegacyKybRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/moderator/kyb/companies/${id}`} replace />;
}
